import { clsx } from 'clsx';

export interface BorderType {
  class?: string;
  top: boolean;
  right: boolean;
  bottom: boolean;
  left: boolean;
};

const data:BorderType = {
  top: false,
  right: false,
  bottom: false,
  left: false,
};

function parser(borders: Array<BorderType> | undefined): BorderType{
  const [border] = borders ?? [data];
  return {
    class: clsx(border.top && "border-t", border.right && "border-r", border.bottom && "border-b", border.left && "border-l"),
    ...border
  };
}

function toClass(borders: Array<BorderType>|undefined){
  const border = parser(borders);
  return clsx(border.top && "border-t", border.right && "border-r", border.bottom && "border-b", border.left && "border-l");
}

export default {
  data,
  parser,
  toClass
}